"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _index = _interopRequireDefault(require("@/components/linkaddress/index.vue"));
var _wxApi = require("@/api/wxApi");
var _clipboard = _interopRequireDefault(require("clipboard"));
var _validate = require("@/utils/validate");
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'linkGenerator',
  components: {
    linkaddress: _index.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      tableFrom: {
        page: 1,
        limit: 20,
        keywords: ''
      },
      keywords: '',
      loading: false,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      formData: {
        expireInterval: 30,
        originalPath: '',
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请填写链接名称',
          trigger: 'blur'
        }],
        originalPath: [{
          required: true,
          message: '请选择跳转页面',
          trigger: 'change'
        }],
        expireInterval: [{
          required: true,
          message: '请填写失效间隔天数',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:wechat:mini:url:link:page:list'])) this.getList(1);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleCopy: function handleCopy() {
      this.$nextTick(function () {
        var _this = this;
        var clipboard = new _clipboard.default('.copy-data');
        clipboard.on('success', function () {
          _this.$message.success('复制成功');
          clipboard.destroy();
        });
      });
    },
    //再次生成
    handleRegenerate: function handleRegenerate(row) {
      this.formData = {
        expireInterval: row.expireInterval,
        originalPath: row.originalPath,
        name: row.name
      };
      this.handlerAdd();
    },
    //新增
    handlerAdd: function handlerAdd() {
      this.dialogVisible = true;
    },
    //关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.formData.resetFields();
    },
    //获取链接地址
    getLinkUrl: function getLinkUrl(e) {
      this.formData.originalPath = e;
    },
    handleGetLink: function handleGetLink() {
      this.$refs.linkaddres.dialogVisible = true;
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this2 = this;
      this.$modalSure('删除该链接吗？').then(function () {
        (0, _wxApi.wechatUrlLinkDeleteApi)(id).then(function () {
          _this2.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this2.tableData.data.length, _this2.tableFrom);
          _this2.getList();
        });
      });
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.loading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      (0, _wxApi.wechatUrlLinkListApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //表单提交
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _wxApi.wechatUrlLinkGenerateApi)(_this4.formData).then(function (res) {
            _this4.$message.success('新增成功');
            _this4.getList(1);
            _this4.handleClose();
          });
        } else {
          return false;
        }
      });
    })
  }
};